<template>
    <div>
        <div v-if="allowedToControlPayments">
            <div class="row">
                <div class="col-lg-7">
                    <p>Manage Accresa Payments:</p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label>
                            No
                            <template v-if="vm.receivesPayment">
                                <input type="checkbox" v-model="vm.receivesPayment" checked="">
                            </template>
                            <template v-else>
                                <input type="checkbox" v-model="vm.receivesPayment">
                            </template>
                            <span class="lever"></span> Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <p class="text-primary">
                        <small>
                            <em>
                                "Yes" indicates that all payments are made directly to the {{ entityConfig.name }}.<br>
                                The {{ entityConfig.name }} is then responsible for distributing
                                payments.
                            </em>
                        </small>
                    </p>
                </div>
            </div>
            <hr>
        </div>

        <div v-if="allowedToControlPlans">
            <div class="row">
                <div class="col-lg-7">
                    <p>
                        Controls Group Offerings:
                    </p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label>
                            No
                            <template v-if="allowedToControlPlans">
                                <input type="checkbox" v-model="vm.controlsPlans" checked="">
                            </template>
                            <template v-else>
                                <input type="checkbox" v-model="vm.controlsPlans">
                            </template>
                            <span class="lever"></span> Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <p class="text-primary">
                        <small>
                            <em>
                                When set to "Yes" {{ entityConfig.name }} will be permitted to set
                                their own membership pricing and features.<br>
                            </em>
                        </small>
                    </p>
                </div>
            </div>
            <hr/>
        </div>
        
        <invoice v-model="vm" :isEdit="false" v-if="allowedToControlInvoice && !isPhysician">
        </invoice>

    </div>
</template>

<script>
import {providerUtilities} from "../utilities.js";
import {api} from "../../../../global/framework/api.js";
import {common} from "../../../../global/common.js";
import Invoice from '../Invoice.vue';

export default {
    components: { Invoice },
    name: "SharedSettings",
    props: {parentEntityId: {type: [Number], default: null}, dataModel: {type: [Object], required: true}},
    data() {
        return {
            vm: {...this.dataModel},
            parent: {},
            entityConfig: {},
            widgetReady: false
        };
    },
    computed: {
        allowedToControlPayments() {
            return this.widgetReady && (!this.hasValue(this.parent) || this.parent.receivesPayment);
        },
        allowedToControlPlans() {
            return this.widgetReady && (!this.hasValue(this.parent) || this.parent.controlsPlans);
        },
        allowedToControlInvoice() {
            return this.widgetReady && (!this.hasValue(this.parent) || this.parent.controlsInvoice);
        },
        showPracticeTypeOption() {
            return this.widgetReady && (this.vm.entityTypeId === common.ENTITY_TYPE.CLINIC || this.isStandAlonePhysician);
        },
        isStandAlonePhysician() {
            return this.vm.entityTypeId === common.ENTITY_TYPE.PHYSICIAN && !this.hasValue(this.vm.parentEntityId);
        },
        isPhysician() {
            return this.widgetReady && this.entityConfig.typeId === common.ENTITY_TYPE.PHYSICIAN;
        },
    },
    async mounted() {
        if (this.hasValue(this.parentEntityId)) {
            this.parent = await api.get('ProviderEntity', this.parentEntityId, 'GetProviderEntity');
            this.entityConfig = providerUtilities.getConfigByParent(this.parent.entityTypeId);
        } else {
            this.entityConfig = providerUtilities.getByEntityTypeId(common.ENTITY_TYPE.NETWORK);
        }

        if (this.vm.entityTypeId === common.ENTITY_TYPE.CLINIC) {
            this.vm.hybridDpc = true;
        }
        this.widgetReady = true;
    },
    methods: {
        getSettings() {
            return {
                receivesPayment: this.vm.receivesPayment,
                controlsPlans: this.vm.controlsPlans,
                hybridDpc: this.vm.hybridDpc,
                controlsInvoice: this.vm.controlsInvoice,
                controlsLineItems: this.vm.controlsLineItems
            };
        }
    }
}
</script>

<style scoped>

</style>